<template>
  <v-container fluid class="py-5 px-5 py-sm-10 px-sm-10 align-start">
    <v-row>
      <v-col cols="12" :md="createOrUpdateTrainingCategory ? 7 : 12" style="transition: all 0.3s ease;">
        <v-row align="center">
          <v-col cols="12" sm="auto" class="text-start">
            <span class="textLight--text font-weight-bold text-h4">
              {{ $t("trainingCategory.trainingCategories") }}
              <span class="text-h6 text--secondary ml-2">({{ trainingCategories.length }})</span>
            </span>
          </v-col>

          <v-spacer />

          <v-col
            v-if="havePermissionCreateTrainingCategory"
            cols="12"
            sm="3"
            md="4"
            lg="3"
          >
            <v-btn
              depressed
              min-height="48"
              block
              color="primary"
              style="text-transform: unset; letter-spacing: 0.5px;"
              class="rounded-lg font-weight-medium elevation-2"
              @click="addNew"
            >
              <v-icon left> mdi-plus </v-icon>
              {{ $t("trainingCategory.add") }}
            </v-btn>
          </v-col>

          <v-col cols="12" sm="12" lg="4">
            <v-text-field
              v-model="search"
              hide-details
              prepend-inner-icon="mdi-magnify"
              color="primary"
              background-color="#F8F8F8"
              :placeholder="$t('course.search')"
              solo
              flat
              clearable
              class="shrink rounded-lg"
              style="border: 1px solid #EBEBEB;"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-5 mt-sm-10">
      <v-col cols="12" :md="createOrUpdateTrainingCategory ? 7 : 12" order="2" order-md="1" style="transition: all 0.3s ease;">
        <v-row>
          <v-col cols="12">
            <CategoryList
              :data="trainingCategories"
              :loading="loading"
              @editTrainingCategoryVal="editTrainingCategoryVal"
              @reFetch="refetch"
              @responseErr="errResponse"
            />
          </v-col>

          <!-- <v-col cols="12" v-if="trainingCategories && trainingCategories.length">
            <div class="d-flex justify-end textLight--text subtitle-2">
              <p
                class="ma-0"
                style="cursor: pointer"
                v-if="pageInput.skip"
                @click="onClickPrev"
              >
                Prev
              </p>

              <p
                class="ma-0 ms-5"
                style="cursor: pointer"
                v-if="
                  totalCount > pageInput.skip + pageInput.limit &&
                  totalCount > pageInput.limit
                "
                @click="onClickNext"
              >
                Next
              </p>
            </div>
          </v-col> -->
        </v-row>
      </v-col>

      <v-col cols="12" md="5" order="1" order-md="2">
        <CreateOrUpdateCategory
          v-if="createOrUpdateTrainingCategory"
          :isCreate="isCreate"
          :trainingCategoryData="editData"
          @close="createOrUpdateTrainingCategory = null"
          @onTrainingCategoryCreate="afterCreate"
        />
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarSuccess" timeout="3000" color="success">
      {{
        snackbarSuccessMessage || $t("course.courseDetails.successfullySave")
      }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbarSuccess = false"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="snackbarError" timeout="3000" color="error">
      {{ snackbarErrorMessage || $t("somethingWentWrong") }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          text
          v-bind="attrs"
          @click="snackbarError = false"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import CategoryList from "@/app/category-module/components/CategoryList";
import CreateOrUpdateCategory from "../components/CreateOrUpdateCategory";

import { hasPermission } from "@/app/user-module/helpers/authHelper";

const defaultPageInput = () => ({
  skip: 0,
  limit: 0,
});

export default {
  name: "CategoriesPage",
  components: {
    CategoryList,
    CreateOrUpdateCategory,
  },
  data() {
    return {
      search: null,
      loading: true,
      trainingCategoriesOg: [],
      trainingCategories: [],
      totalCount: null,
      pageInput: defaultPageInput(),
      filterInput: null,
      debounceSearch: null,
      editData: {},
      createOrUpdateTrainingCategory: null,
      isCreate: null,
      snackbarSuccess: false,
      snackbarError: false,
      snackbarSuccessMessage: null,
      snackbarErrorMessage: null,
    };
  },
  apollo: {
    getTrainingCategories() {
      return {
        query: require("../api/query/getTrainingCategories.gql"),
        variables: {
          pageInput: this.pageInput,
          // filterInput: this.filterInput,
        },
        result({ data, loading }) {
          if (data?.getTrainingCategories?.trainingCategories) {
            this.trainingCategoriesOg =
              data.getTrainingCategories.trainingCategories;
            this.trainingCategories = this.trainingCategoriesOg;
            this.totalCount = data.getTrainingCategories.totalCount;
          }

          this.loading = loading;
        },
      };
    },
  },
  watch: {
    search() {
      clearTimeout(this.debounceSearch);

      this.debounceSearch = setTimeout(() => {
        // TODO: search from api not need now, do later if need.
        // this.apiSearch();
        this.localSearch();
      }, 500);
    },
  },
  computed: {
    havePermissionCreateTrainingCategory() {
      return hasPermission({
        currentRole: this.$store.state.authenticatedUserRole,
        currentPermissions: this.$store.state.authenticatedUserPermissions,
        requiredPermission: ["CREATE_TRAINING_CATEGORY"],
        restrictOrganizationManager:
          this.$store.state.authenticatedUser?.isOrganizationManager,
      });
    },
  },
  methods: {
    apiSearch() {
      const searchText = this.search?.trim() ?? "";

      if (searchText.length > 3) {
        this.pageInput = defaultPageInput();
        this.filterInput = { search: searchText };
        this.refetch();
      } else if (searchText.length === 0 && this.filterInput?.search != null) {
        this.pageInput = defaultPageInput();
        this.filterInput = null;
        this.refetch();
      }
    },
    localSearch() {
      const searchText = this.search?.trim()?.toLowerCase() ?? "";

      if (searchText.length > 2) {
        this.trainingCategories = this.trainingCategoriesOg.reduce(
          (result, item) => {
            if (
              item.name?.findIndex(
                x =>
                  x.value?.toLowerCase()?.indexOf(searchText.toLowerCase()) >= 0
              ) >= 0
            ) {
              result.push(item);
            }

            return result;
          },
          []
        );
      } else if (searchText.length === 0) {
        this.trainingCategories = this.trainingCategoriesOg;
      }
    },
    addNew() {
      this.editData = {};
      this.isCreate = true;
      this.createOrUpdateTrainingCategory = true;
    },
    editTrainingCategoryVal(val) {
      if (val) {
        this.editData = val;
        this.isCreate = false;
        this.createOrUpdateTrainingCategory = true;
      }
    },
    onClickNext() {
      this.pageInput.skip += this.pageInput.limit;
      this.refetch();
    },
    onClickPrev() {
      this.pageInput.skip -= this.pageInput.limit;
      this.refetch();
    },
    afterCreate() {
      this.pageInput = defaultPageInput();
      this.filterInput = null;
      this.search = null;

      // this.refetch();
    },
    errResponse(msg) {
      if (msg) this.snackbarErrorMessage = msg;
      this.snackbarError = true;
    },
    async refetch() {
      this.createOrUpdateTrainingCategory = false;

      await this.$apollo.queries.getTrainingCategories.refetch({
        pageInput: this.pageInput,
        // filterInput: this.filterInput,
      });
    },
  },
};
</script>
